(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lestang-hero-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeBanner = (section) => {
      if (section.dataset.initialized === 'true') return;

      const viewport = section.querySelector('.lestang-banner__viewport');
      const slides = [...section.querySelectorAll('[data-banner-slide]')];
      const dots = [...section.querySelectorAll('[data-banner-dot]')];
      const glitchImage = section.querySelector('[data-banner-glitch-image]');
      const previous = section.querySelector('[data-banner-prev]');
      const next = section.querySelector('[data-banner-next]');
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let activeIndex = Math.max(0, slides.findIndex((slide) => slide.classList.contains('is-active')));
      let glitchTimer;
      let glitchFrame;
      let autoplayTimer;
      let resizeFrame;
      let updateToken = 0;
      let touchStartX = 0;
      let touchStartY = 0;
      let swipePointerId = null;
      let swipeCaptured = false;
      let swipeHandled = false;

      if (!viewport || slides.length === 0) return;
      section.dataset.initialized = 'true';

      const visualLeftRatio = 226 / 2402;
      const visualTopRatio = 112 / 2402;
      const visualWidthRatio = 1950 / 2402;
      const visualHeightRatio = 1114 / 2402;

      const syncVisualBounds = () => {
        const image = slides[activeIndex]?.querySelector('.lestang-banner__image');
        if (!image) return;

        const viewportRect = viewport.getBoundingClientRect();
        const naturalWidth = image.naturalWidth || viewportRect.width;
        const naturalHeight = image.naturalHeight || viewportRect.height;
        const imageRatio = naturalWidth / naturalHeight;
        const viewportRatio = viewportRect.width / viewportRect.height;
        let imageWidth = viewportRect.width;
        let imageHeight = viewportRect.height;
        let imageLeft = 0;
        let imageTop = 0;

        if (imageRatio > viewportRatio) {
          imageHeight = imageWidth / imageRatio;
          imageTop = (viewportRect.height - imageHeight) / 2;
        } else {
          imageWidth = imageHeight * imageRatio;
          imageLeft = (viewportRect.width - imageWidth) / 2;
        }

        const isMobile = window.matchMedia('(max-width: 749px)').matches;
        let visualInsetX;
        let visualInsetY;
        let visualLeft;
        let visualTop;
        let visualWidth;
        let visualHeight;

        if (isMobile) {
          imageWidth = viewportRect.width / visualWidthRatio;
          imageHeight = imageWidth / imageRatio;
          visualInsetX = Math.round(imageWidth * visualLeftRatio);
          visualInsetY = Math.round(imageWidth * visualTopRatio);
          imageLeft = -visualInsetX;
          imageTop = -visualInsetY;
          visualLeft = 0;
          visualTop = 0;
          visualWidth = Math.round(viewportRect.width);
          visualHeight = Math.round(viewportRect.height);
        } else {
          visualInsetX = Math.round(imageWidth * visualLeftRatio);
          visualInsetY = Math.round(imageWidth * visualTopRatio);
          visualLeft = Math.round(imageLeft + visualInsetX);
          visualTop = Math.round(imageTop + visualInsetY);
          visualWidth = Math.min(
            Math.round(imageWidth - visualInsetX),
            Math.round(imageWidth * visualWidthRatio)
          );
          visualHeight = Math.min(
            Math.round(imageHeight - visualInsetY),
            Math.round(imageWidth * visualHeightRatio)
          );
        }
        const hotzoneWidth = Math.max(54, Math.min(100, Math.round(visualWidth * .08)));
        const controlInset = Math.max(8, Math.min(28, Math.round(visualWidth * .02)));
        const controlWidth = window.matchMedia('(max-width: 749px)').matches ? 34 : 46;

        viewport.style.setProperty('--lestang-banner-image-left', `${Math.round(imageLeft)}px`);
        viewport.style.setProperty('--lestang-banner-image-top', `${Math.round(imageTop)}px`);
        viewport.style.setProperty('--lestang-banner-image-width', `${Math.round(imageWidth)}px`);
        viewport.style.setProperty('--lestang-banner-image-height', `${Math.round(imageHeight)}px`);
        viewport.style.setProperty('--lestang-banner-slide-width', `${Math.round(imageWidth)}px`);
        viewport.style.setProperty('--lestang-banner-slide-height', `${Math.round(imageHeight)}px`);
        viewport.style.setProperty('--lestang-banner-visual-left', `${visualLeft}px`);
        viewport.style.setProperty('--lestang-banner-visual-top', `${visualTop}px`);
        viewport.style.setProperty('--lestang-banner-visual-width', `${visualWidth}px`);
        viewport.style.setProperty('--lestang-banner-visual-height', `${visualHeight}px`);
        viewport.style.setProperty('--lestang-banner-glitch-offset-x', `${visualInsetX}px`);
        viewport.style.setProperty('--lestang-banner-glitch-offset-y', `${visualInsetY}px`);
        viewport.style.setProperty('--lestang-banner-hotzone-width', `${hotzoneWidth}px`);
        viewport.style.setProperty(
          '--lestang-banner-control-prev-left',
          `${visualLeft + controlInset - (controlWidth / 2)}px`
        );
        viewport.style.setProperty(
          '--lestang-banner-control-next-left',
          `${visualLeft + visualWidth - controlInset - (controlWidth / 2)}px`
        );
        if (glitchImage && !isMobile) {
          glitchImage.style.backgroundImage = `url("${image.currentSrc || image.src}")`;
        } else if (glitchImage) {
          glitchImage.style.backgroundImage = 'none';
        }
      };

      const scheduleVisualSync = () => {
        window.cancelAnimationFrame(resizeFrame);
        resizeFrame = window.requestAnimationFrame(() => {
          window.requestAnimationFrame(syncVisualBounds);
        });
      };

      const triggerGlitch = () => {
        if (reducedMotion) return;
        syncVisualBounds();
        window.clearTimeout(glitchTimer);
        window.cancelAnimationFrame(glitchFrame);
        viewport.classList.remove('is-glitching');
        glitchFrame = window.requestAnimationFrame(() => {
          viewport.classList.add('is-glitching');
          const duration = window.matchMedia('(max-width: 749px)').matches ? 290 : 430;
          glitchTimer = window.setTimeout(() => viewport.classList.remove('is-glitching'), duration);
        });
      };

      const hydrateSlide = (slide) => {
        const image = slide?.querySelector('.lestang-banner__image');
        if (!image) return Promise.resolve();

        slide.querySelectorAll('source[data-srcset]').forEach((source) => {
          source.srcset = source.dataset.srcset;
          source.removeAttribute('data-srcset');
        });

        if (image.dataset.srcset) {
          image.srcset = image.dataset.srcset;
          image.removeAttribute('data-srcset');
        }

        if (image.dataset.src) {
          image.src = image.dataset.src;
          image.removeAttribute('data-src');
        }

        if (image.complete && image.naturalWidth > 1) return Promise.resolve();

        return new Promise((resolve) => {
          image.addEventListener('load', resolve, { once: true });
          image.addEventListener('error', resolve, { once: true });
        });
      };

      const commitUpdate = (nextIndex, animate) => {
        activeIndex = nextIndex;

        slides.forEach((slide, index) => {
          const isActive = index === activeIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });

        dots.forEach((dot, index) => {
          const isActive = index === activeIndex;
          dot.classList.toggle('is-active', isActive);
          dot.setAttribute('aria-current', isActive ? 'true' : 'false');
        });

        scheduleVisualSync();
        if (animate) triggerGlitch();
      };

      const update = (nextIndex, animate = true) => {
        const targetIndex = (nextIndex + slides.length) % slides.length;
        const token = ++updateToken;
        hydrateSlide(slides[targetIndex]).then(() => {
          if (token !== updateToken) return;
          commitUpdate(targetIndex, animate);
        });
      };

      const pulse = (control) => {
        if (!control || reducedMotion) return;
        control.classList.add('is-pressed');
        window.setTimeout(() => control.classList.remove('is-pressed'), 180);
      };

      const restartAutoplay = () => {
        window.clearInterval(autoplayTimer);
        if (section.dataset.autoplay !== 'true' || slides.length < 2) return;
        const interval = Math.max(3000, Number(section.dataset.interval) || 3000);
        autoplayTimer = window.setInterval(() => update(activeIndex + 1), interval);
      };

      section.querySelectorAll('[data-banner-hotzone]').forEach((hotzone) => {
        const className = hotzone.dataset.bannerHotzone === 'prev' ? 'is-prev-hot' : 'is-next-hot';
        hotzone.addEventListener('mouseenter', () => {
          viewport.classList.add(className);
          const direction = hotzone.dataset.bannerHotzone === 'prev' ? -1 : 1;
          hydrateSlide(slides[(activeIndex + direction + slides.length) % slides.length]);
        });
        hotzone.addEventListener('mouseleave', () => viewport.classList.remove(className));
      });

      viewport.addEventListener('mouseleave', () => {
        viewport.classList.remove('is-prev-hot', 'is-next-hot');
      });

      previous?.addEventListener('click', () => {
        pulse(previous);
        update(activeIndex - 1);
        restartAutoplay();
      });

      next?.addEventListener('click', () => {
        pulse(next);
        update(activeIndex + 1);
        restartAutoplay();
      });

      viewport.addEventListener('pointerdown', (event) => {
        if (event.button !== 0) return;
        if (event.target.closest('button, input, select, textarea, summary')) return;
        hydrateSlide(slides[(activeIndex + 1) % slides.length]);
        swipePointerId = event.pointerId;
        touchStartX = event.clientX;
        touchStartY = event.clientY;
        swipeCaptured = false;
        swipeHandled = false;
      });

      viewport.addEventListener('pointermove', (event) => {
        if (event.pointerId !== swipePointerId || swipeCaptured) return;
        const deltaX = event.clientX - touchStartX;
        const deltaY = event.clientY - touchStartY;
        if (Math.abs(deltaX) < 10 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
        swipeCaptured = true;
        viewport.setPointerCapture?.(event.pointerId);
      });

      viewport.addEventListener('pointerup', (event) => {
        if (event.pointerId !== swipePointerId) return;
        swipePointerId = null;
        const deltaX = event.clientX - touchStartX;
        const deltaY = event.clientY - touchStartY;
        if (Math.abs(deltaX) < 46 || Math.abs(deltaX) <= Math.abs(deltaY) * 1.15) {
          swipeCaptured = false;
          return;
        }
        event.preventDefault();
        swipeCaptured = false;
        swipeHandled = true;
        update(activeIndex + (deltaX < 0 ? 1 : -1));
        restartAutoplay();
        window.setTimeout(() => { swipeHandled = false; }, 420);
      });

      viewport.addEventListener('pointercancel', () => {
        swipePointerId = null;
        swipeCaptured = false;
        swipeHandled = false;
      });

      viewport.addEventListener('click', (event) => {
        if (!swipeHandled) return;
        event.preventDefault();
        event.stopPropagation();
      }, true);

      dots.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          dot.classList.add('is-pressed');
          window.setTimeout(() => dot.classList.remove('is-pressed'), 180);
          update(index);
          restartAutoplay();
        });
      });

      slides.forEach((slide) => {
        const image = slide.querySelector('.lestang-banner__image');
        if (image && !image.complete && !image.dataset.src) {
          image.addEventListener('load', scheduleVisualSync, { once: true });
        }
      });

      const warmNextSlide = () => hydrateSlide(slides[(activeIndex + 1) % slides.length]);
      const scheduleWarmNextSlide = () => {
        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(warmNextSlide, { timeout: 3000 });
        } else {
          window.setTimeout(warmNextSlide, 1800);
        }
      };

      if (document.readyState === 'complete') {
        scheduleWarmNextSlide();
      } else {
        window.addEventListener('load', scheduleWarmNextSlide, { once: true });
      }

      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(scheduleVisualSync);
        resizeObserver.observe(viewport);
      } else {
        window.addEventListener('resize', scheduleVisualSync, { passive: true });
      }

      document.addEventListener('shopify:block:select', (event) => {
        const block = event.target.closest('[data-banner-slide]');
        if (!block || !section.contains(block)) return;
        update(Number(block.dataset.index), false);
      });

      update(activeIndex, false);
      restartAutoplay();
    };

    const initializeAllBanners = () => {
      document.querySelectorAll('[data-lestang-banner]').forEach(initializeBanner);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAllBanners, { once: true });
    } else {
      initializeAllBanners();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('[data-lestang-banner]');
      if (section) initializeBanner(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-lestang"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeCollection = (section) => {
      if (!section) return;
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const filterToggles = section.querySelectorAll('[data-lestang-filter-toggle]');
      const sortWrap = section.querySelector('[data-lestang-sort-wrap]');
      const sortToggle = section.querySelector('[data-lestang-sort-toggle]');
      const filterForm = section.querySelector('[data-lestang-filter-form]');
      const filterStorageKey = `lestang-filter-open:${window.location.pathname}`;
      const hasFilterParams = Array.from(new URLSearchParams(window.location.search).keys())
        .some((name) => name.startsWith('filter.'));

      if (hasFilterParams || sessionStorage.getItem(filterStorageKey) === 'true') {
        section.classList.add('has-filter');
        filterToggles.forEach((toggle) => toggle.setAttribute('aria-expanded', 'true'));
      }

      filterToggles.forEach((button) => {
        button.addEventListener('click', () => {
          const open = section.classList.toggle('has-filter');
          filterToggles.forEach((toggle) => toggle.setAttribute('aria-expanded', String(open)));
          sessionStorage.setItem(filterStorageKey, String(open));
        });
      });

      sortToggle?.addEventListener('click', () => {
        const open = sortWrap.classList.toggle('is-open');
        sortToggle.setAttribute('aria-expanded', String(open));
      });

      section.querySelectorAll('[data-sort-value]').forEach((option) => {
        option.addEventListener('click', () => {
          const url = new URL(window.location.href);
          url.searchParams.set('sort_by', option.dataset.sortValue);
          window.location.assign(url.toString());
        });
      });

      section.querySelectorAll('[data-lestang-filter-group-toggle]').forEach((button) => {
        button.addEventListener('click', () => {
          const group = button.closest('[data-lestang-filter-group]');
          const open = group.classList.toggle('is-open');
          button.setAttribute('aria-expanded', String(open));
        });
      });

      filterForm?.querySelectorAll('input[type="checkbox"][name]').forEach((input) => {
        input.addEventListener('change', () => {
          sessionStorage.setItem(filterStorageKey, 'true');
          filterForm.submit();
        });
      });

      const mobileCards = window.matchMedia('(max-width: 760px)');

      section.querySelectorAll('.lestang-product-card__image > a').forEach((link) => {
        link.addEventListener('click', (event) => {
          if (!mobileCards.matches) return;

          const card = link.closest('[data-lestang-product-card]');
          if (!card || card.classList.contains('is-mobile-selected')) return;

          event.preventDefault();
          section.querySelectorAll('.lestang-product-card.is-mobile-selected').forEach((selectedCard) => {
            selectedCard.classList.remove('is-mobile-selected');
          });
          card.classList.add('is-mobile-selected');
        });
      });

      section.querySelectorAll('[data-lestang-quick-add]').forEach((form) => {
        form.addEventListener('submit', async (event) => {
          event.preventDefault();
          const button = form.querySelector('button');
          const label = form.querySelector('.lestang-product-card__add-label');
          button.disabled = true;
          if (label) label.textContent = 'Adding...';
          if (!mobileCards.matches) {
            window.LestangCart?.open({ refreshCart: false });
          }

          try {
            const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({
                items: [{ id: Number(form.elements.id.value), quantity: 1 }]
              })
            });
            if (!response.ok) throw new Error('Unable to add product');
            const cartLink = document.querySelector('[data-lestang-cart-link]');
            const count = cartLink?.querySelector('.lestang-header__bag-count');
            if (cartLink && count) {
              const nextCount = (Number(count.textContent) || 0) + 1;
              count.textContent = nextCount;
              cartLink.classList.add('has-items');
            }
            if (label) label.textContent = 'Added';
            window.LestangCart?.refresh();
          } catch (error) {
            if (label) label.textContent = 'Try Again';
          } finally {
            window.setTimeout(() => {
              button.disabled = false;
              if (label) label.textContent = 'Add to Cart';
            }, 350);
          }
        });
      });

      document.addEventListener('click', (event) => {
        if (sortWrap && !sortWrap.contains(event.target)) {
          sortWrap.classList.remove('is-open');
          sortToggle?.setAttribute('aria-expanded', 'false');
        }

        if (mobileCards.matches && !event.target.closest('[data-lestang-product-card]')) {
          section.querySelectorAll('.lestang-product-card.is-mobile-selected').forEach((card) => {
            card.classList.remove('is-mobile-selected');
          });
        }
      });
    };

    const initializeAllCollections = () => {
      document.querySelectorAll('[data-lestang-collection]').forEach(initializeCollection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAllCollections, { once: true });
    } else {
      initializeAllCollections();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeCollection(event.target.querySelector('[data-lestang-collection]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-lottery-index-lestang"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initialize = (section) => {
      if (!section || section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const tabs = [...section.querySelectorAll('[data-lottery-filter]')];
      const groups = [...section.querySelectorAll('[data-lottery-group]')];

      const localDateFormatter = new Intl.DateTimeFormat(document.documentElement.lang || undefined, {
        year: 'numeric',
        month: 'short',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit',
        timeZoneName: 'short'
      });

      section.querySelectorAll('[data-lottery-local-time]').forEach((output) => {
        const value = Number(output.dataset.lotteryLocalTime) * 1000;
        if (Number.isFinite(value)) output.textContent = localDateFormatter.format(new Date(value));
      });

      groups.forEach((group) => {
        const list = group.querySelector('[data-lottery-list]');
        const empty = group.querySelector('[data-lottery-empty]');
        if (list && empty && list.children.length === 0) empty.hidden = false;
      });

      const applyFilter = (filter) => {
        tabs.forEach((tab) => {
          const active = tab.dataset.lotteryFilter === filter;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-pressed', String(active));
        });

        groups.forEach((group) => {
          const name = group.dataset.lotteryGroup;
          group.hidden = filter === 'all' ? name === 'entries' : name !== filter;
        });
      };

      tabs.forEach((tab) => tab.addEventListener('click', () => applyFilter(tab.dataset.lotteryFilter)));
      section.querySelector('[data-lottery-show-all]')?.addEventListener('click', () => applyFilter('all'));
      applyFilter('entries');
    };

    const initializeAllLotteryIndexes = () => {
      document.querySelectorAll('[data-lottery-index]').forEach(initialize);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAllLotteryIndexes, { once: true });
    } else {
      initializeAllLotteryIndexes();
    }

    document.addEventListener('shopify:section:load', (event) => initialize(event.target.querySelector('[data-lottery-index]')));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-lottery-lestang"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeLottery = (section) => {
      if (!section) return;
      if (section.dataset.lotteryBound === 'true') return;
      section.dataset.lotteryBound = 'true';

      const labels = JSON.parse(section.querySelector('[data-lottery-labels]')?.textContent || '{}');
      const liquidRecord = JSON.parse(section.querySelector('[data-lottery-customer-record]')?.textContent || 'null');
      const accountProfile = JSON.parse(section.querySelector('[data-lottery-account-profile]')?.textContent || 'null');
      const releaseId = section.dataset.releaseId;
      const releaseTitle = section.dataset.releaseTitle;
      const appProxyPath = String(section.dataset.appProxyPath || '/apps/lestang-lottery').replace(/\/$/, '');
      const campaignReference = section.dataset.campaignReference || releaseId;
      const campaignEndpoint = `${appProxyPath}/campaigns/${encodeURIComponent(campaignReference)}`;
      const isLoggedIn = section.dataset.customerLoggedIn === 'true';
      const startAt = Date.parse(section.dataset.entryStart || '');
      const endAt = Date.parse(section.dataset.entryEnd || '');
      const drawAt = Date.parse(section.dataset.drawAt || '');
      const forcedStatus = section.dataset.forcedStatus || 'auto';
      const form = section.querySelector('.lestang-lottery__form');
      const login = section.querySelector('[data-lottery-login]');
      const closed = section.querySelector('[data-lottery-closed]');
      const receipt = section.querySelector('[data-lottery-receipt]');
      const statusLabel = section.querySelector('[data-lottery-status-label]');
      const countdownLabel = section.querySelector('[data-lottery-countdown-label]');
      const countdown = section.querySelector('[data-lottery-countdown]');
      const formError = form?.querySelector('[data-lottery-form-error]');
      let remoteRecord = null;
      let remoteCampaignState = '';

      const entryForRelease = () => {
        const accountRecord = remoteRecord || liquidRecord;
        if (accountRecord?.status) {
          return {
            releaseId,
            releaseTitle,
            reference: accountRecord.reference || '—',
            submittedAt: accountRecord.submittedAt,
            status: String(accountRecord.status).toLowerCase(),
            paymentDeadline: accountRecord.paymentDeadline,
            paymentUrl: accountRecord.paymentUrl
          };
        }
        return null;
      };

      const formatDate = (value) => {
        const timestamp = typeof value === 'number' ? value : Date.parse(value || '');
        if (!Number.isFinite(timestamp)) return '—';
        return new Intl.DateTimeFormat(document.documentElement.lang || undefined, {
          year: 'numeric',
          month: 'short',
          day: '2-digit',
          hour: '2-digit',
          minute: '2-digit',
          timeZoneName: 'short'
        }).format(new Date(timestamp));
      };

      const renderLocalTime = (selector, value) => {
        const output = section.querySelector(selector);
        if (!output) return;
        output.textContent = formatDate(value);
        if (Number.isFinite(value)) output.dateTime = new Date(value).toISOString();
      };

      renderLocalTime('[data-lottery-start-label]', startAt);
      renderLocalTime('[data-lottery-end-label]', endAt);
      renderLocalTime('[data-lottery-draw-label]', drawAt);

      const automaticState = (now = Date.now()) => {
        if (!Number.isFinite(startAt) && !Number.isFinite(endAt) && !Number.isFinite(drawAt)) return 'upcoming';
        if (Number.isFinite(startAt) && now < startAt) return 'upcoming';
        if (Number.isFinite(endAt) && now < endAt) return 'open';
        if (Number.isFinite(drawAt) && now < drawAt) return 'closed';
        if (!Number.isFinite(drawAt)) return Number.isFinite(endAt) ? 'closed' : 'open';
        return 'drawing';
      };

      const currentState = () => remoteCampaignState || (forcedStatus === 'auto' ? automaticState() : forcedStatus);

      const stateTarget = (state) => {
        if (state === 'upcoming') return startAt;
        if (state === 'open') return endAt;
        if (state === 'closed') return drawAt;
        return NaN;
      };

      const stateCopy = {
        upcoming: {
          status: labels.statusUpcoming,
          countdown: labels.countdownStarts,
          title: labels.entryUpcoming,
          copy: labels.entryUpcomingCopy,
          step: 0
        },
        open: {
          status: labels.statusOpen,
          countdown: labels.countdownEnds,
          title: '',
          copy: '',
          step: 1
        },
        closed: {
          status: labels.statusClosed,
          countdown: labels.countdownDraw,
          title: labels.entryClosed,
          copy: labels.entryClosedCopy,
          step: 2
        },
        drawing: {
          status: labels.statusDrawing,
          countdown: labels.countdownComplete,
          title: labels.entryDrawing,
          copy: labels.entryDrawingCopy,
          step: 2
        },
        announced: {
          status: labels.statusAnnounced,
          countdown: labels.countdownComplete,
          title: labels.entryAnnounced,
          copy: labels.entryAnnouncedCopy,
          step: 3
        }
      };

      const renderSteps = (activeIndex) => {
        section.querySelectorAll('[data-lottery-steps] li').forEach((item, index) => {
          item.classList.toggle('is-complete', index < activeIndex);
          item.classList.toggle('is-active', index === activeIndex);
        });
      };

      const resultStatuses = new Set(['winner', 'selected', 'pending_payment', 'paid', 'not_selected', 'expired']);

      const renderOutcome = (entry) => {
        const outcome = receipt.querySelector('[data-lottery-outcome]');
        const title = outcome.querySelector('[data-lottery-outcome-title]');
        const copy = outcome.querySelector('[data-lottery-outcome-copy]');
        const deadlineWrap = outcome.querySelector('[data-lottery-payment-deadline-wrap]');
        const deadline = outcome.querySelector('[data-lottery-payment-deadline]');
        const paymentLink = outcome.querySelector('[data-lottery-payment-link]');
        const status = entry.status;
        let outcomeTitle = '';
        let outcomeCopy = '';

        if (['winner', 'selected', 'pending_payment'].includes(status)) {
          outcomeTitle = labels.statusSelected;
          outcomeCopy = labels.selectedCopy;
        } else if (status === 'paid') {
          outcomeTitle = labels.statusPaid;
          outcomeCopy = labels.paidCopy;
        } else if (status === 'not_selected') {
          outcomeTitle = labels.statusNotSelected;
          outcomeCopy = labels.notSelectedCopy;
        } else if (status === 'expired') {
          outcomeTitle = labels.statusExpired;
          outcomeCopy = labels.expiredCopy;
        }

        outcome.hidden = !resultStatuses.has(status);
        if (outcome.hidden) return;
        title.textContent = outcomeTitle;
        copy.textContent = outcomeCopy;
        const deadlineValue = Date.parse(entry.paymentDeadline || '');
        deadlineWrap.hidden = !Number.isFinite(deadlineValue) || !['winner', 'selected', 'pending_payment'].includes(status);
        deadline.textContent = Number.isFinite(deadlineValue) ? formatDate(deadlineValue) : '';
        paymentLink.hidden = !entry.paymentUrl || !['winner', 'selected', 'pending_payment'].includes(status);
        if (!paymentLink.hidden) paymentLink.href = entry.paymentUrl;
      };

      const renderReceipt = (entry, state) => {
        if (!entry || entry.status === 'pending') return false;
        if (form) form.hidden = true;
        if (login) login.hidden = true;
        closed.hidden = true;
        receipt.hidden = false;
        receipt.querySelector('[data-lottery-reference]').textContent = entry.reference;
        receipt.querySelector('[data-lottery-submitted]').textContent = formatDate(entry.submittedAt);
        const entryStatus = ['winner', 'selected', 'pending_payment'].includes(entry.status)
          ? labels.statusSelected
          : entry.status === 'paid'
            ? labels.statusPaid
            : entry.status === 'not_selected'
              ? labels.statusNotSelected
              : entry.status === 'expired'
                ? labels.statusExpired
                : entry.status === 'review'
                  ? labels.entryStatusReview
                  : entry.status === 'waiting_draw'
                    ? labels.entryStatusDraw
                    : state === 'open'
                      ? labels.entryStatusReview
                      : state === 'upcoming'
                        ? labels.entryStatusRegistered
                        : state === 'announced'
                          ? labels.entryStatusResult
                          : labels.entryStatusDraw;
        receipt.querySelector('[data-lottery-entry-status]').textContent = entryStatus;
        renderOutcome(entry);
        return true;
      };

      const renderState = () => {
        const state = currentState();
        const copy = stateCopy[state] || stateCopy.drawing;
        const entry = entryForRelease();
        statusLabel.textContent = copy.status;
        countdownLabel.textContent = copy.countdown;
        renderSteps(copy.step);

        if (renderReceipt(entry, state)) return state;

        receipt.hidden = true;
        if (state === 'open') {
          if (form) form.hidden = false;
          if (login) login.hidden = isLoggedIn;
          closed.hidden = true;
        } else {
          if (form) form.hidden = true;
          if (login) login.hidden = true;
          closed.hidden = false;
          closed.querySelector('[data-lottery-closed-title]').textContent = copy.title;
          closed.querySelector('[data-lottery-closed-copy]').textContent = copy.copy;
        }
        return state;
      };

      const renderCountdown = () => {
        const state = renderState();
        const target = stateTarget(state);
        const remaining = Math.max(0, Number.isFinite(target) ? target - Date.now() : 0);
        const totalSeconds = Math.floor(remaining / 1000);
        const values = {
          days: Math.floor(totalSeconds / 86400),
          hours: Math.floor((totalSeconds % 86400) / 3600),
          minutes: Math.floor((totalSeconds % 3600) / 60),
          seconds: totalSeconds % 60
        };
        Object.entries(values).forEach(([key, value]) => {
          const output = countdown.querySelector(`[data-${key}]`);
          if (output) output.textContent = String(value).padStart(2, '0');
        });
      };

      const mapRemoteStatus = (status) => ({
        UNDER_REVIEW: 'review',
        WINNER_PAYMENT_PENDING: 'pending_payment',
        WAITLIST_PENDING: 'waiting_draw',
        PAID: 'paid',
        PAYMENT_EXPIRED: 'expired',
        NOT_ELIGIBLE: 'not_selected',
        NOT_SELECTED: 'not_selected'
      })[status] || 'review';

      const mapCampaignState = (status) => ({
        SCHEDULED: 'upcoming',
        OPEN: 'open',
        CLOSED: 'closed',
        REVIEW: 'drawing',
        ELIGIBLE_LOCKED: 'drawing',
        DRAW_PREVIEW: 'drawing',
        PAYMENT: 'announced',
        COMPLETED: 'announced',
        ENDED_UNFILLED: 'announced',
        CANCELLED: 'closed'
      })[status] || '';

      const normalizeRemoteRecord = (record) => record ? {
        reference: record.reference,
        submittedAt: record.submittedAt,
        status: mapRemoteStatus(record.status),
        paymentDeadline: record.paymentDeadline,
        paymentUrl: record.paymentUrl
      } : null;

      const selectedExistingAddress = () => {
        const selectedId = form?.elements.selectedAddressId?.value;
        return accountProfile?.addresses?.find((address) => String(address.id) === String(selectedId));
      };

      const readNewAddress = () => {
        const countrySelect = form.elements.newCountryCode;
        const countryOption = countrySelect.options[countrySelect.selectedIndex];
        return {
          firstName: form.elements.newFirstName.value.trim(),
          lastName: form.elements.newLastName.value.trim(),
          company: form.elements.newCompany.value.trim(),
          address1: form.elements.newAddress1.value.trim(),
          address2: form.elements.newAddress2.value.trim(),
          city: form.elements.newCity.value.trim(),
          province: form.elements.newProvince.value.trim(),
          country: countryOption?.dataset.countryName || countryOption?.textContent.trim() || '',
          countryCode: countrySelect.value,
          zip: form.elements.newZip.value.trim(),
          phone: form.elements.newPhone.value.trim()
        };
      };

      const syncAddressInterface = () => {
        if (!form) return;
        const usesNewAddress = form.elements.selectedAddressId?.value === '__new__';
        const newAddressFields = form.querySelector('[data-lottery-new-address]');
        newAddressFields.hidden = !usesNewAddress;
        ['newAddress1', 'newCity', 'newCountryCode', 'newZip'].forEach((name) => {
          form.elements[name].required = usesNewAddress;
        });
        const address = usesNewAddress ? readNewAddress() : selectedExistingAddress();
        const countryCode = String(address?.countryCode || '').toUpperCase();
        const countryName = String(address?.country || '').toLowerCase();
        const isTaiwan = countryCode === 'TW' || ['台湾', '台灣', 'taiwan'].includes(countryName);
        const identity = form.querySelector('[data-lottery-identity]');
        identity.hidden = !isTaiwan;
        form.elements.identityType.required = isTaiwan;
        form.elements.identityValue.required = isTaiwan;
      };

      const validateIdentity = () => {
        const input = form.elements.identityValue;
        if (!input.required) {
          input.setCustomValidity('');
          return true;
        }
        const value = input.value.replace(/[\s-]/g, '').toUpperCase();
        const type = form.elements.identityType.value;
        const valid = type === 'NATIONAL_ID'
          ? /^[A-Z][12]\d{8}$/.test(value)
          : type === 'ARC'
            ? /^[A-Z][89]\d{8}$/.test(value)
            : /^[A-Z0-9]{6,20}$/.test(value);
        input.setCustomValidity(valid ? '' : labels.identityInvalid);
        return valid;
      };

      form?.addEventListener('change', (event) => {
        if (event.target.name === 'selectedAddressId' || event.target.name === 'newCountryCode') syncAddressInterface();
        if (event.target.name === 'identityType' || event.target.name === 'identityValue') validateIdentity();
      });

      form?.addEventListener('submit', async (event) => {
        event.preventDefault();
        formError.hidden = true;
        syncAddressInterface();
        validateIdentity();
        if (!form.reportValidity()) return;
        const usesNewAddress = form.elements.selectedAddressId.value === '__new__';
        const submit = form.querySelector('[data-lottery-submit]');
        submit.disabled = true;
        const payload = {
          fullName: form.elements.fullName.value.trim(),
          phone: form.elements.phone.value.trim(),
          instagram: form.elements.instagram.value.trim(),
          language: form.elements.language.value,
          rulesAccepted: form.elements.rulesAccepted.checked,
          website: form.elements.website.value,
          accountProfile,
          selectedAddressId: usesNewAddress ? null : form.elements.selectedAddressId.value,
          newAddress: usesNewAddress ? readNewAddress() : null,
          saveAddressAsDefault: usesNewAddress && form.elements.saveAddressAsDefault.checked,
          identityDocument: form.elements.identityValue.required ? {
            type: form.elements.identityType.value,
            value: form.elements.identityValue.value
          } : null
        };
        try {
          const response = await fetch(`${campaignEndpoint}/entries`, {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(payload)
          });
          const result = await response.json();
          if (!response.ok) throw new Error(result.error?.message || labels.submissionFailed);
          remoteRecord = {
            reference: result.reference,
            submittedAt: result.submittedAt,
            status: mapRemoteStatus(result.status)
          };
          renderState();
        } catch (error) {
          formError.textContent = error.message || labels.submissionFailed;
          formError.hidden = false;
          submit.disabled = false;
        }
      });

      const loadStorefrontState = async () => {
        if (!isLoggedIn) return;
        try {
          const response = await fetch(campaignEndpoint, { credentials: 'same-origin', cache: 'no-store' });
          const result = await response.json();
          if (!response.ok) throw new Error(result.error?.message || labels.campaignUnavailable);
          remoteCampaignState = mapCampaignState(result.campaign.status);
          remoteRecord = normalizeRemoteRecord(result.entry);
          renderState();
        } catch (error) {
          if (!form || entryForRelease()) return;
          formError.textContent = error.message || labels.campaignUnavailable;
          formError.hidden = false;
          form.querySelector('[data-lottery-submit]').disabled = true;
        }
      };

      syncAddressInterface();
      renderCountdown();
      loadStorefrontState();
      const intervalId = window.setInterval(renderCountdown, 1000);
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.detail.sectionId === section.id.replace('LestangLottery-', '')) {
          window.clearInterval(intervalId);
        }
      });
    };

    const initializeAllLotteries = () => {
      document.querySelectorAll('[data-lestang-lottery]').forEach(initializeLottery);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAllLotteries, { once: true });
    } else {
      initializeAllLotteries();
    }

    document.addEventListener('shopify:section:load', (event) => {
      initializeLottery(event.target.querySelector('[data-lestang-lottery]'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product-lestang"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initializeProduct = (section) => {
      if (section.dataset.initialized === 'true') return;
      section.dataset.initialized = 'true';

      const slides = [...section.querySelectorAll('[data-lestang-product-slide]')];
      const thumbnails = [...section.querySelectorAll('[data-lestang-product-thumbnail]')];
      const expandedItems = [...section.querySelectorAll('[data-lestang-product-expanded-item]')];
      const gallery = section.querySelector('[data-lestang-product-gallery]');
      const thumbnailViewport = section.querySelector('.lestang-product__thumbnail-viewport');
      const expandedMedia = section.querySelector('[data-lestang-product-expanded-media]');
      const viewAllButton = section.querySelector('[data-lestang-product-view-all]');
      const collapseButton = section.querySelector('[data-lestang-product-collapse]');
      const counter = section.querySelector('[data-lestang-product-counter]');
      const previousButton = section.querySelector('[data-lestang-product-prev]');
      const nextButton = section.querySelector('[data-lestang-product-next]');
      const form = section.querySelector('[data-lestang-product-form]');
      const variantId = section.querySelector('[data-lestang-product-variant-id]');
      const variantSelect = section.querySelector('[data-lestang-product-variant-select]');
      const price = section.querySelector('[data-lestang-product-price]');
      const addButton = section.querySelector('[data-lestang-product-add]');
      const addLabel = section.querySelector('[data-lestang-product-add-label]');
      const buyNow = section.querySelector('[data-lestang-product-buy-now]');
      const quantity = section.querySelector('[data-lestang-quantity]');
      const message = section.querySelector('[data-lestang-product-message]');
      const modal = section.querySelector('[data-lestang-product-modal]');
      const lightbox = section.querySelector('[data-lestang-product-lightbox]');
      const lightboxImage = section.querySelector('[data-lestang-product-lightbox-image]');
      const lightboxPrevious = section.querySelector('[data-lestang-product-lightbox-previous]');
      const lightboxNext = section.querySelector('[data-lestang-product-lightbox-next]');
      const labels = {
        adding: section.dataset.labelAdding,
        added: section.dataset.labelAdded,
        addError: section.dataset.labelAddError,
        checkoutError: section.dataset.labelCheckoutError
      };
      let activeIndex = 0;
      const mobileLightboxQuery = window.matchMedia('(max-width: 860px)');
      const lightboxPointers = new Map();
      let lightboxScale = 1;
      let lightboxTranslateX = 0;
      let lightboxTranslateY = 0;
      let lightboxDragStart = null;
      let lightboxPinchDistance = 0;
      let lightboxPinchScale = 1;
      let lightboxGestureMoved = false;
      let lightboxImageRequest = 0;
      const lightboxImageCache = new Map();

      const normalizeIndex = (index) => {
        if (!slides.length) return 0;
        return (index + slides.length) % slides.length;
      };

      const prepareSlide = (index, priority = false) => {
        const slide = slides[normalizeIndex(index)];
        const image = slide?.querySelector('img');
        if (!(image instanceof HTMLImageElement)) return;
        image.loading = 'eager';
        if (priority) image.fetchPriority = 'high';
      };

      const preloadLightboxSource = (index) => {
        const slide = slides[normalizeIndex(index)];
        const source = slide?.dataset.lestangProductFullImage;
        if (!source) return Promise.resolve(null);
        if (lightboxImageCache.has(source)) return lightboxImageCache.get(source);

        const request = new Promise((resolve) => {
          const image = new Image();
          image.decoding = 'async';
          image.onload = () => {
            const decoded = typeof image.decode === 'function' ? image.decode().catch(() => {}) : Promise.resolve();
            decoded.then(() => resolve(source));
          };
          image.onerror = () => resolve(null);
          image.src = source;
        });

        lightboxImageCache.set(source, request);
        return request;
      };

      const warmAdjacentMedia = (index) => {
        if (slides.length < 2) return;
        prepareSlide(index - 1);
        prepareSlide(index + 1);
      };

      const warmAdjacentLightboxImages = (index) => {
        if (slides.length < 2) return;
        preloadLightboxSource(index - 1);
        preloadLightboxSource(index + 1);
      };

      const positionLightboxControls = () => {
        if (!lightbox?.open || !lightboxImage || !lightboxPrevious || !lightboxNext || mobileLightboxQuery.matches) return;
        const imageBounds = lightboxImage.getBoundingClientRect();
        if (!imageBounds.width || !imageBounds.height) return;

        const viewportInset = 10;
        const imageGap = 8;
        const previousWidth = lightboxPrevious.offsetWidth || 58;
        const nextWidth = lightboxNext.offsetWidth || 58;
        const previousLeft = Math.max(viewportInset, imageBounds.left - previousWidth - imageGap);
        const nextLeft = Math.min(window.innerWidth - nextWidth - viewportInset, imageBounds.right + imageGap);

        lightboxPrevious.style.left = `${previousLeft}px`;
        lightboxPrevious.style.right = 'auto';
        lightboxNext.style.left = `${nextLeft}px`;
        lightboxNext.style.right = 'auto';
      };

      if (lightboxImage && typeof ResizeObserver === 'function') {
        new ResizeObserver(positionLightboxControls).observe(lightboxImage);
      }

      const applyLightboxTransform = () => {
        if (!lightboxImage) return;
        lightboxImage.style.transform = `translate3d(${lightboxTranslateX}px, ${lightboxTranslateY}px, 0) scale(${lightboxScale})`;
        lightboxImage.classList.toggle('is-zoomed', lightboxScale > 1.01);
      };

      const resetLightboxTransform = () => {
        lightboxPointers.clear();
        lightboxScale = 1;
        lightboxTranslateX = 0;
        lightboxTranslateY = 0;
        lightboxDragStart = null;
        lightboxPinchDistance = 0;
        lightboxPinchScale = 1;
        lightboxGestureMoved = false;
        applyLightboxTransform();
      };

      const pointerDistance = () => {
        const points = [...lightboxPointers.values()];
        if (points.length < 2) return 0;
        return Math.hypot(points[0].x - points[1].x, points[0].y - points[1].y);
      };

      const showMedia = (requestedIndex) => {
        if (!slides.length) return;
        activeIndex = normalizeIndex(requestedIndex);
        prepareSlide(activeIndex, true);
        slides.forEach((slide, index) => {
          const active = index === activeIndex;
          slide.hidden = !active;
          slide.classList.toggle('is-active', active);
        });
        thumbnails.forEach((thumbnail, index) => {
          const active = index === activeIndex;
          thumbnail.classList.toggle('is-active', active);
          thumbnail.setAttribute('aria-current', active ? 'true' : 'false');
          if (active) thumbnail.scrollIntoView({ behavior: 'instant', block: 'nearest', inline: 'center' });
        });
        expandedItems.forEach((item, index) => {
          const active = index === activeIndex;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-current', active ? 'true' : 'false');
        });
        if (counter) counter.textContent = `${activeIndex + 1} of ${slides.length}`;
        window.requestAnimationFrame(() => warmAdjacentMedia(activeIndex));
      };

      previousButton?.addEventListener('click', () => showMedia(activeIndex - 1));
      nextButton?.addEventListener('click', () => showMedia(activeIndex + 1));
      previousButton?.addEventListener('pointerenter', () => prepareSlide(activeIndex - 1));
      nextButton?.addEventListener('pointerenter', () => prepareSlide(activeIndex + 1));
      let suppressThumbnailClick = false;
      thumbnails.forEach((thumbnail) => {
        const index = Number(thumbnail.dataset.lestangProductThumbnail);
        thumbnail.addEventListener('pointerenter', () => prepareSlide(index));
        thumbnail.addEventListener('click', (event) => {
          if (suppressThumbnailClick) {
            event.preventDefault();
            return;
          }
          showMedia(index);
        });
      });
      expandedItems.forEach((item) => item.addEventListener('click', () => showMedia(Number(item.dataset.lestangProductExpandedItem))));

      if (thumbnailViewport) {
        let dragState = null;
        thumbnailViewport.addEventListener('pointerdown', (event) => {
          if (event.pointerType !== 'mouse' || event.button !== 0) return;
          dragState = { pointerId: event.pointerId, startX: event.clientX, startScroll: thumbnailViewport.scrollLeft, moved: false };
        });
        thumbnailViewport.addEventListener('pointermove', (event) => {
          if (!dragState || dragState.pointerId !== event.pointerId) return;
          const distance = event.clientX - dragState.startX;
          if (!dragState.moved && Math.abs(distance) > 8) {
            dragState.moved = true;
            suppressThumbnailClick = true;
            thumbnailViewport.classList.add('is-dragging');
            thumbnailViewport.setPointerCapture(event.pointerId);
          }
          if (dragState.moved) {
            event.preventDefault();
            thumbnailViewport.scrollLeft = dragState.startScroll - distance;
          }
        });
        const finishThumbnailDrag = (event) => {
          if (!dragState || dragState.pointerId !== event.pointerId) return;
          const moved = dragState.moved;
          dragState = null;
          thumbnailViewport.classList.remove('is-dragging');
          if (thumbnailViewport.hasPointerCapture(event.pointerId)) thumbnailViewport.releasePointerCapture(event.pointerId);
          if (moved) window.setTimeout(() => { suppressThumbnailClick = false; }, 0);
        };
        thumbnailViewport.addEventListener('pointerup', finishThumbnailDrag);
        thumbnailViewport.addEventListener('pointercancel', finishThumbnailDrag);
      }

      viewAllButton?.addEventListener('click', () => {
        if (window.matchMedia('(min-width: 861px)').matches) {
          gallery?.classList.add('is-expanded');
          if (expandedMedia) expandedMedia.hidden = false;
          viewAllButton.setAttribute('aria-expanded', 'true');
        } else {
          modal?.showModal();
        }
      });
      collapseButton?.addEventListener('click', () => {
        gallery?.classList.remove('is-expanded');
        if (expandedMedia) expandedMedia.hidden = true;
        viewAllButton?.setAttribute('aria-expanded', 'false');
        viewAllButton?.focus({ preventScroll: true });
      });
      section.querySelector('[data-lestang-product-modal-close]')?.addEventListener('click', () => modal?.close());
      modal?.addEventListener('click', (event) => {
        if (event.target === modal) modal.close();
      });

      const updateLightboxImage = (animate = false) => {
        const request = ++lightboxImageRequest;
        const activeSlide = slides[activeIndex];
        const activeImage = activeSlide?.querySelector('img');
        const thumbnailImage = thumbnails[activeIndex]?.querySelector('img');
        const previewSource =
          (activeImage?.complete && activeImage?.naturalWidth > 1 ? activeImage.currentSrc : '')
          || thumbnailImage?.currentSrc
          || thumbnailImage?.src
          || activeImage?.currentSrc
          || activeImage?.src;
        const fullSource = activeSlide?.dataset.lestangProductFullImage || previewSource;
        if (!fullSource || !lightboxImage) return;
        resetLightboxTransform();
        lightboxImage.classList.remove('is-switching');
        if (previewSource) lightboxImage.src = previewSource;
        if (animate && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          window.requestAnimationFrame(() => {
            if (request === lightboxImageRequest) lightboxImage.classList.add('is-switching');
          });
        }

        preloadLightboxSource(activeIndex).then((source) => {
          if (!source || request !== lightboxImageRequest) return;
          lightboxImage.src = source;
        });
        window.requestAnimationFrame(() => {
          warmAdjacentMedia(activeIndex);
          warmAdjacentLightboxImages(activeIndex);
        });
      };

      const changeLightboxMedia = (step) => {
        showMedia(activeIndex + step);
        updateLightboxImage(true);
      };

      const zoomButton = section.querySelector('[data-lestang-product-zoom]');
      zoomButton?.addEventListener('pointerenter', () => {
        preloadLightboxSource(activeIndex);
        warmAdjacentLightboxImages(activeIndex);
      });
      zoomButton?.addEventListener('click', () => {
        if (!lightbox || !lightboxImage) return;
        updateLightboxImage(false);
        lightbox.showModal();
        window.requestAnimationFrame(positionLightboxControls);
      });

      lightboxImage?.addEventListener('pointerdown', (event) => {
        if (!mobileLightboxQuery.matches) return;
        event.preventDefault();
        lightboxPointers.set(event.pointerId, { x: event.clientX, y: event.clientY });
        lightboxImage.setPointerCapture(event.pointerId);

        if (lightboxPointers.size === 1) {
          lightboxGestureMoved = false;
          lightboxDragStart = {
            x: event.clientX,
            y: event.clientY,
            translateX: lightboxTranslateX,
            translateY: lightboxTranslateY
          };
        } else if (lightboxPointers.size === 2) {
          lightboxGestureMoved = true;
          lightboxPinchDistance = pointerDistance();
          lightboxPinchScale = lightboxScale;
        }
      });

      lightboxImage?.addEventListener('pointermove', (event) => {
        if (!mobileLightboxQuery.matches || !lightboxPointers.has(event.pointerId)) return;
        event.preventDefault();
        lightboxPointers.set(event.pointerId, { x: event.clientX, y: event.clientY });

        if (lightboxPointers.size >= 2 && lightboxPinchDistance > 0) {
          lightboxGestureMoved = true;
          lightboxScale = Math.min(4, Math.max(1, lightboxPinchScale * pointerDistance() / lightboxPinchDistance));
          if (lightboxScale === 1) {
            lightboxTranslateX = 0;
            lightboxTranslateY = 0;
          }
          applyLightboxTransform();
          return;
        }

        if (lightboxPointers.size === 1 && lightboxDragStart && lightboxScale > 1.01) {
          const distanceX = event.clientX - lightboxDragStart.x;
          const distanceY = event.clientY - lightboxDragStart.y;
          if (Math.abs(distanceX) > 3 || Math.abs(distanceY) > 3) lightboxGestureMoved = true;
          lightboxTranslateX = lightboxDragStart.translateX + distanceX;
          lightboxTranslateY = lightboxDragStart.translateY + distanceY;
          applyLightboxTransform();
        }
      });

      const finishLightboxPointer = (event, cancelled = false) => {
        if (!mobileLightboxQuery.matches || !lightboxPointers.has(event.pointerId)) return;
        const closeOnTap = !cancelled && lightboxPointers.size === 1 && !lightboxGestureMoved;
        lightboxPointers.delete(event.pointerId);
        if (lightboxImage.hasPointerCapture(event.pointerId)) lightboxImage.releasePointerCapture(event.pointerId);

        if (lightboxPointers.size === 1) {
          const remaining = [...lightboxPointers.values()][0];
          lightboxDragStart = {
            x: remaining.x,
            y: remaining.y,
            translateX: lightboxTranslateX,
            translateY: lightboxTranslateY
          };
        } else if (lightboxPointers.size === 0) {
          lightboxDragStart = null;
          lightboxPinchDistance = 0;
        }

        if (closeOnTap) lightbox?.close();
      };

      lightboxImage?.addEventListener('pointerup', (event) => finishLightboxPointer(event));
      lightboxImage?.addEventListener('pointercancel', (event) => finishLightboxPointer(event, true));
      lightboxImage?.addEventListener('load', positionLightboxControls);
      lightboxImage?.addEventListener('animationend', () => {
        lightboxImage.classList.remove('is-switching');
        positionLightboxControls();
      });
      lightboxPrevious?.addEventListener('click', () => changeLightboxMedia(-1));
      lightboxNext?.addEventListener('click', () => changeLightboxMedia(1));
      lightboxPrevious?.addEventListener('pointerenter', () => preloadLightboxSource(activeIndex - 1));
      lightboxNext?.addEventListener('pointerenter', () => preloadLightboxSource(activeIndex + 1));
      section.querySelector('[data-lestang-product-lightbox-close]')?.addEventListener('click', () => lightbox?.close());
      lightbox?.addEventListener('click', (event) => {
        if (event.target === lightbox) lightbox.close();
      });
      lightbox?.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          changeLightboxMedia(-1);
        }
        if (event.key === 'ArrowRight') {
          event.preventDefault();
          changeLightboxMedia(1);
        }
      });
      lightbox?.addEventListener('close', resetLightboxTransform);

      section.querySelector('[data-lestang-quantity-minus]')?.addEventListener('click', () => {
        quantity.value = Math.max(Number(quantity.min) || 1, (Number(quantity.value) || 1) - 1);
      });
      section.querySelector('[data-lestang-quantity-plus]')?.addEventListener('click', () => {
        quantity.value = (Number(quantity.value) || 1) + 1;
      });

      variantSelect?.addEventListener('change', () => {
        const option = variantSelect.selectedOptions[0];
        variantId.value = option.value;
        price.textContent = option.dataset.price;
        const available = option.dataset.available === 'true';
        addButton.disabled = !available;
        buyNow.disabled = !available;
      });

      const addCurrentVariant = async () => {
        const response = await fetch(`${window.Shopify?.routes?.root || '/'}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({
            items: [{ id: Number(variantId.value), quantity: Math.max(1, Number(quantity.value) || 1) }]
          })
        });
        if (!response.ok) throw new Error('Unable to add product');
        return response.json();
      };

      form?.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (addButton.disabled) return;
        addButton.disabled = true;
        message.textContent = '';
        const originalLabel = addLabel.textContent;
        addLabel.textContent = labels.adding;
        try {
          await addCurrentVariant();
          addLabel.textContent = labels.added;
          await window.LestangCart?.refresh();
          if (!window.matchMedia('(max-width: 760px)').matches) window.LestangCart?.open({ refreshCart: false });
        } catch (error) {
          message.textContent = labels.addError;
        } finally {
          window.setTimeout(() => {
            addButton.disabled = false;
            addLabel.textContent = originalLabel;
          }, 350);
        }
      });

      buyNow?.addEventListener('click', async () => {
        if (buyNow.disabled) return;
        buyNow.disabled = true;
        message.textContent = '';
        try {
          await addCurrentVariant();
          window.location.assign('/checkout');
        } catch (error) {
          message.textContent = labels.checkoutError;
          buyNow.disabled = false;
        }
      });
      prepareSlide(activeIndex, true);
      window.requestAnimationFrame(() => warmAdjacentMedia(activeIndex));
    };

    const initializeAllProducts = () => {
      document.querySelectorAll('[data-lestang-product]').forEach(initializeProduct);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initializeAllProducts, { once: true });
    } else {
      initializeAllProducts();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('[data-lestang-product]');
      if (section) initializeProduct(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
